var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.75C8.025 0.75 0.75 8.025 0.75 17C0.75 25.975 8.025 33.25 17 33.25C25.975 33.25 33.25 25.975 33.25 17C33.25 8.025 25.975 0.75 17 0.75ZM26.0725 12.3837L14.215 24.24C13.9175 24.5362 13.4363 24.5362 13.1388 24.24L12.9 24.0012L12.8988 24.0025L6.375 17.4325C6.0775 17.135 6.0775 16.6525 6.375 16.355L7.9925 14.7388C8.29 14.4412 8.7725 14.4412 9.07 14.7388L13.6813 19.3837L23.3762 9.68875C23.6737 9.39125 24.1562 9.39125 24.4537 9.68875L26.0713 11.3062C26.37 11.6025 26.37 12.085 26.0725 12.3837Z",
    fill: "#FA68E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.689f4c75f32c8e153b3f790748571b56.svg";
export { ForwardRef as ReactComponent };